import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseAddMutation, IAddFn, IGetPostRequest, ITrainingCategory, ITrainingCategoryUpsert } from '../../interfaces'

const getAddTrainingCategoryMutationRequest: IGetPostRequest = params => {
  return {
    method: 'post',
    url: `${config.baseUrl}/TrainingCategories`,
  }
}

const useAddTrainingCategoryMutation: IUseAddMutation<ITrainingCategory, ITrainingCategoryUpsert> = (params, options = {}) => {
  const request = useMemo(() => getAddTrainingCategoryMutationRequest(params), [params])

  const addTraining: IAddFn<ITrainingCategoryUpsert, ITrainingCategory> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingCategory, Error, any>({
    mutationFn: addTraining,
    ...options,
  })

  return response
}

export default useAddTrainingCategoryMutation
